import React, { Component } from "react";
import { Row, Image, Col } from "react-bootstrap";
import "./EstimatorFooter.css";
import logo from "../img/dm_logo.png";
import { HashLink } from "react-router-hash-link";

export default class EstimatorNavBar extends Component {
  renderDemoButton() {
    if (this.props.isAuthenticated) {
      return <HashLink to="/beta/">DEMO</HashLink>;
    } else {
      return <HashLink to="/register/">DEMO</HashLink>;
    }
  }

  renderSignUpButton() {
    if (this.props.isAuthenticated) {
      return <HashLink to="/beta/">SIGN UP</HashLink>;
    } else {
      return <HashLink to="/register/">SIGN UP</HashLink>;
    }
  }

  render() {
    return (
      <Row className="estimator-footer">
        <Row>
          <p>
            COPYRIGHT© {new Date().getFullYear()}{" "}
            <a
              href="http://www.digimasters.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              DIGIMASTERS UK
            </a>{" "}
            ALL RIGHTS RESERVED
          </p>
        </Row>
        <Row>
          <Col xs={12} md={9}>
            QUICK LINKS: <HashLink to="/">HOME</HashLink> |{" "}
            <HashLink to="/blog#tutorial">TUTORIAL</HashLink> |{" "}
            {this.renderDemoButton()} | {this.renderSignUpButton()} |{" "}
            <HashLink to="/blog/">BLOG</HashLink> |{" "}
            <a
              href="http://digimasters.co.uk/privacy-cookies-policy.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              PRIVACY & COOKIES
            </a>
          </Col>
          <Col xs={12} md={3} className="logo-col">
            <a
              href="http://www.digimasters.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={logo} />
            </a>
          </Col>
        </Row>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EstimatorFooter.js